<template>
<div class="container-fluid">
  
  
  <div class="bg-light border border-warning rounded-pill " >

  
  <!--<div class="alert_ alert-warning_ border border-warning text-black" role="alert">-->
    <span class="alert-heading_ ">
    <strong><span class="ml-3">
      <!--<i style="color:black" class="fas fa-info-circle mr-4 ml-3 mt-1" aria-hidden="true"></i>-->
          
        <!--{{props.create_at}}-->
    </span>
    <span class="ml-4 mr-4">TOTALE <span style="color:blue">{{ fmt1(props.total)}} €</span></span> 
    <span class="mr-4" v-if="props.discount != '0.00'">
      ABBUONO <span style="color:blue">{{ fmt1(props.discount)}} €</span> </span> 
    <!--<span v-if="props.discount != '0.00'"> SCONTO CASSA  {{ total_discount }} %</span>-->
    <span class="mr-1">PAGAMENTO </span>
    <span :style="{color: item.typeId == 'CRED' ? 'red' : 'blueviolet'}" class="mr-3" v-for="(item, index) in props.items" :key="index">
    {{ fmt1(item.amount) }}  {{ item.typeId }}
  </span>
  </strong>  
</span>


</div>

<button v-if="balance && props.customerId" @click="$emit('setPayment')" type="button"  data-toggle="tooltip" title="Salda e ritira" class="btn btn-info border border-danger  btn-lg btn-block  mt-1 ">            
              <i style="color:yellow;font-size: 26px;"  class="fas fa-check_ mr-2" aria-hidden="true"></i>
              <strong>SALDA E RITIRA</strong>
</button>            
          

</div>



</template>
<script>
import fmt                from '@/components/mixins/fmt.js'

export default {
mixins    : [fmt],
props     : ['props'],

data() {
    return {     
      balance : 0        
    };
  },

computed  : 
  {
    total_discount : function()
    {
      const total = this.props.discount / this.props.total * 100.00      
      return total.toFixed(2)
    }

  },
  created () 
    { 
     
     this.props.items.forEach(item =>{
    if(item.typeId == 'CRED')
     {
      this.balance = item.amount
     }
     }) 
    /*console.log(this.props)        */
          
    }

}
</script>
<style scoped>
.bg-light
{
  background-color: rgb(210, 230, 230)!important;

  
  
}
span {

  font-size : 24px;
  color     :  black;
}

h4{
  color    :  rgb(236, 45, 45);
}
</style>


